var exports = {
  "D": "xfd349460--7fb889--title",
  "Q": "xfd349460--7fb889--content",
};

module.exports = exports;
